const stats = [
  {
    value: '100%',
    label: 'iOS Focused',
    desc: 'Every product we build is crafted exclusively for the Apple ecosystem.',
    bg: 'bg-stone-800',
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-28 px-8 md:px-20 bg-stone-50">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 mb-20">
          <div className="lg:w-2/5">
            <p className="text-stone-400 text-sm uppercase tracking-widest mb-4">Who We Are</p>
            <h2
              className="text-4xl md:text-5xl font-light text-stone-900 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              A Team of<br />
              <em className="italic text-stone-600">Dedicated Experts</em><br />
              in iOS Development
            </h2>
          </div>

          <div className="lg:w-3/5 flex flex-col justify-center">
            <p className="text-stone-600 text-lg leading-relaxed mb-6">
              <strong>OSMICA, d.o.o.</strong> is a Slovenia-based software company with a singular focus:
              building modern, high-quality applications for the iOS platform. Our team combines
              deep technical expertise with a passion for clean, intuitive design.
            </p>
            <p className="text-stone-500 text-base leading-relaxed">
              We believe that great software should be invisible — it should simply work, protect,
              and empower the people who use it. From privacy tools to device optimization utilities,
              every product we release reflects our commitment to excellence and user trust.
            </p>
          </div>
        </div>

        {/* Stats cards */}
        <div className="grid grid-cols-1 gap-6">
          {stats.map((s) => (
            <div
              key={s.label}
              className={`${s.bg} rounded-2xl p-10 flex flex-col justify-between min-h-[220px]`}
            >
              <div className="text-6xl font-thin text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
                {s.value}
              </div>
              <div>
                <p className="text-white text-xl font-medium mb-2">{s.label}</p>
                <p className="text-white/60 text-sm leading-relaxed">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Values row */}
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-8 border-t border-stone-200 pt-16">
          {[
            { icon: 'ri-shield-check-line', title: 'Security First', desc: 'We build with privacy and protection at the core of every feature.' },
            { icon: 'ri-smartphone-line', title: 'Native iOS', desc: 'Pure Swift development — no cross-platform compromises, ever.' },
            { icon: 'ri-user-heart-line', title: 'User-Centric', desc: 'Every decision is guided by what makes the experience better for real people.' },
          ].map((v) => (
            <div key={v.title} className="flex flex-col gap-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-stone-200 text-stone-700">
                <i className={`${v.icon} text-xl`} />
              </div>
              <h3 className="text-stone-900 font-semibold text-base">{v.title}</h3>
              <p className="text-stone-500 text-sm leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
